import defaultSettings from '@/settings'

const title = defaultSettings.title || '广东日芝电梯有限公司'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
